import { useMemo } from 'react'

import { SpaceNotificationPreference } from '@tribeplatform/gql-client/types'
import { useI18n } from '@tribeplatform/react-components/i18n'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'

import {
  MemberNotificationSettingOptions,
  SpaceDefaultNotificationSettingOptions,
} from './utils'

export const NotificationPreferences = ({
  value,
  onChange,
  showDescriptions = true,
  context = 'memberSettings',
}: {
  value: SpaceNotificationPreference
  onChange: (newValue: SpaceNotificationPreference) => void
  showDescriptions?: boolean
  context?: 'memberSettings' | 'defaultSettings'
}) => {
  const intl = useI18n()
  const options = useMemo(() => {
    if (context === 'memberSettings') {
      return MemberNotificationSettingOptions(intl)
    }
    return SpaceDefaultNotificationSettingOptions(intl)
  }, [context, intl])

  return (
    <RadioGroup value={value} onChange={onChange}>
      <RadioGroup.Items>
        {options.map(option => (
          <RadioGroup.Item
            key={option.value}
            value={option.value}
            title={option.label}
            description={showDescriptions && option.description}
          />
        ))}
      </RadioGroup.Items>
    </RadioGroup>
  )
}
